//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useEffect, useState } from 'react'
import { ReportDataShape, ReportDataShapeLabel, ReportDataShapesForLender } from '@shared/ReportDefinitionCTO'
import LenderTimePeriodPageTerm from '@react/reporting/LenderTimePeriodPageTerm'
import LenderTimePeriodPageFlex from '@react/reporting/LenderTimePeriodPageFlex'
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material'
import PoolEventTimePeriodPage from '@react/reporting/PoolEventTimePeriodPage'
import LenderTimePeriodPageDynamic from '@react/reporting/LenderTimePeriodPageDynamic'

export default function ReportingPage(): React.ReactElement {
  const [reportDataShape, setReportDataShape] = useState<ReportDataShape>(ReportDataShape.UNKNOWN)

  useEffect(function initialReportSelect() {
    const reportDataShape = localStorage.getItem('reportDataShape') as ReportDataShape | undefined

    if (reportDataShape) {
      setReportDataShape(reportDataShape)
    } else {
      setReportDataShape(ReportDataShape.LENDER_TIME_PERIOD_TERM_LENDER)
    }
  }, [])
  const handleReportDataShapeChange = (event: SelectChangeEvent) => {
    const shape = event.target.value as ReportDataShape
    localStorage.setItem('reportDataShape', shape)
    setReportDataShape(shape)
  }
  return (
    <div>
      <Paper sx={{ padding: 4, margin: 2, borderRadius: 4 }}>
        <Typography variant="h4" fontWeight={'bold'} align="left">
          Reports
        </Typography>
        <FormControl sx={{ m: 1, width: 350, padding: '15px', marginTop: '40px' }}>
          <InputLabel id="reportShape-label">Report</InputLabel>
          <Select
            style={{ width: 350 }}
            labelId="reportShape-label"
            id="reportShape-select"
            input={<OutlinedInput id="reportShape-select" label="Report Shape" />}
            value={reportDataShape}
            renderValue={(value: string) => {
              return (
                <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
                  {ReportDataShapeLabel[value as ReportDataShape]}
                </Typography>
              )
            }}
            onChange={handleReportDataShapeChange}
          >
            {ReportDataShapesForLender.map((value) => {
              return (
                <MenuItem
                  value={value}
                  key={`${value}`}
                  style={{
                    paddingLeft: 12,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
                    {ReportDataShapeLabel[value as ReportDataShape]}
                  </Typography>
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        {reportDataShape === ReportDataShape.LENDER_TIME_PERIOD_TERM_LENDER && (
          <LenderTimePeriodPageTerm isLender={true} />
        )}
        {reportDataShape === ReportDataShape.LENDER_TIME_PERIOD_FLEX_LENDER && (
          <LenderTimePeriodPageFlex isLender={true} />
        )}
        {reportDataShape === ReportDataShape.LENDER_TIME_PERIOD_DYNAMIC_LENDER && (
          <LenderTimePeriodPageDynamic isLender={true} />
        )}
        {reportDataShape === ReportDataShape.POOL_EVENTS_LENDER && <PoolEventTimePeriodPage />}
      </Paper>
    </div>
  )
}
